import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import Frontpage from './Frontpage.vue';
import config from '../../../config';

VueI18nHelper.initVueI18NextForPage(Frontpage, `.frontpage-vue`, [config.locize.frontPage.namespaces.FRONTPAGE, config.locize.frontPage.namespaces.PARTNERSHOP], config.locize.frontPage.PROJECTID);
